import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ToggleSwitchChangeEvent, ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormLabelComponent } from '../form-label/form-label.component';

@Component({
    selector: 'toggle-switch-fc',
    standalone: true,
    imports: [ToggleSwitchModule, ReactiveFormsModule, FormLabelComponent],
    templateUrl: './toggle-switch-fc.component.html',
    styleUrl: './toggle-switch-fc.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleSwitchFcComponent {
    id = input.required<string>();
    control = input.required<FormControl>();

    label = input<string>('');
    tooltipText = input<string>('');

    required = input<boolean>(false);
    disabled = input<boolean>(false);

    onChange = output<ToggleSwitchChangeEvent>();
}
